<template>
  <sprite class="icon" :name="name">
  </sprite>
</template>

<script>
import Sprite from './Sprite.vue'

export default {
  name: 'icon',

  props: {
    name: String
  },

  components: {
    Sprite
  }
}
</script>

<style lang="sass">
  @import '../../styles/base/variables'

  .icon
    width: 16px
    height: 16px
    transition: fill $transition-duration $transition-easing

    fill: #FFFFFF
</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/Icon.vue